<template>
  <OmtLayoutHeaderFooter
    :footer="true"
    :bg="['#F6F6F9', '#F6F6F9']"
    :header="{ titleLabel: 'Plano de medicamentos' }"
  >
    <OmtGrid>
      <OmtRow>
        <OmtCard
          bg="white"
          p="16px"
          borderRadius="16px"
        >
          <CImage
            :src="partnerLogos"
            alt="Omint e VidaLink"
            class="partner-logos"
            mb="16px"
          />

          <OmtTypography
            as="h3-bold"
            lineHeight="22px"
            mb="12px"
          >
            Aproveite o benefício farmácia: créditos para comprar medicamentos.
          </OmtTypography>

          <OmtTypography
            as="p1"
            lineHeight="22px"
            mb="12px"
            color="#4E4E4E"
          >
            Com a parceria entre Omint e VidaLink, você conta com um saldo mensal para a compra de medicamentos em
            farmácias credenciadas em todo o Brasil. Os valores disponíveis seguem o plano contratado pela sua empresa.
          </OmtTypography>

          <OmtTypography
            as="p1"
            lineHeight="22px"
            mb="20px"
            color="#4E4E4E"
          >
            Para aproveitá-lo, <strong>acesse o app VidaLink</strong>, siga os passos para o primeiro acesso.
          </OmtTypography>

          <OmtButton
            borderRadius="30px"
            width="100%"
            :size="buttonSize"
            :is-disabled="loadingLink"
            @click="openVidaLink"
          >
            <OmtTypography
              as="h3-bold"
              color="white"
              mb="0"
              >Acesse o app Vidalink</OmtTypography
            >
          </OmtButton>
        </OmtCard>
      </OmtRow>

      <OmtRow
        mt="24px"
        stack
      >
        <OmtTypography
          as="h3-bold"
          mb="12px"
          >Soluções disponíveis</OmtTypography
        >
        <OmtCard
          bg="white"
          p="16px"
          borderRadius="16px"
        >
          <ul class="solutions">
            <li>Consulta de saldo de medicamentos e comprar em qualquer farmácia do Brasil.</li>
            <li>Busca de farmácias credenciadas.</li>
            <li>Validação de receita e solicitação reembolso (quando aplicável).</li>
          </ul>
        </OmtCard>
      </OmtRow>
    </OmtGrid>
  </OmtLayoutHeaderFooter>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { mapState } from "vuex";
import { ObterLinkVidaLink } from "@/api/vidaLink";

const partnerLogos = process.env.VUE_APP_BASE_URL + "images/plano-medicamentos/omint-vidalink.png";

export default {
  data() {
    return {
      partnerLogos,
      loadingLink: false,
      isMobileLayout: globalThis.window.innerWidth < 1024
    };
  },
  computed: {
    ...mapState("saude", ["vinculo"]),
    buttonSize() {
      return this.isMobileLayout ? "xs" : "lg";
    }
  },
  mounted() {
    this.$root.$emit("hide-loading");
    globalThis.window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    globalThis.window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.isMobileLayout = globalThis.window.innerWidth < 1024;
    },
    isIosSafari() {
      const ua = navigator.userAgent || "";
      if (/iPhone|iPad|iPod/i.test(ua)) return true;
      return navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    },
    openVidaLinkUrl(url) {
      if (this.isIosSafari()) {
        globalThis.window.location.href = url;
        return;
      }
      globalThis.window.open(url, "_blank");
    },
    async openVidaLink() {
      if (this.loadingLink) return;
      this.loadingLink = true;
      this.$root.$emit("show-loading");
      try {
        const response = await ObterLinkVidaLink({ vinculo: this.vinculo });
        const data = response?.Data;

        if (data?.Elegivel && data?.Url) {
          const url = `${data.Url}${String(data.Url).includes("?") ? "&" : "?"}fileType=.pdf`;
          this.openVidaLinkUrl(url);
          return;
        }

        if (data && data.Elegivel === false) {
          await Swal.fire({
            icon: "warning",
            text: "Não foi possível acessar o app VidaLink. Confira se CPF, data de nascimento, telefone e e-mail estão cadastrados.",
            confirmButtonText: "OK"
          });
          return;
        }

        await Swal.fire({
          icon: "error",
          text: response?.Error || "Ocorreu um erro ao obter o link da VidaLink.",
          confirmButtonText: "OK"
        });
      } catch (error) {
        globalThis.window.$log.error("ObterLinkVidaLink", error);
        await Swal.fire({
          icon: "error",
          text: "Ocorreu um erro ao obter o link da VidaLink.",
          confirmButtonText: "OK"
        });
      } finally {
        this.loadingLink = false;
        this.$root.$emit("hide-loading");
      }
    },
    openDetails() {
      // destino de "Confira todos os detalhes" ainda não informado
    }
  }
};
</script>

<style scoped>
.partner-logos {
  display: block;
  height: 16px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
  object-position: left center;
}

.solutions {
  margin: 0 0 16px;
  padding-left: 18px;
}

.solutions li {
  font-size: 14px;
  line-height: 22px;
  color: #4e4e4e;
  margin-bottom: 8px;
}
</style>
